import React from "react";
import { Box, Center, Spinner } from "@chakra-ui/react";

export default function LoadingOverlay() {
  return (
    <Box
      position="fixed"
      inset={0}
      bg="rgba(240,240,240,0.6)"
      backdropFilter="blur(4px)"
      zIndex={9999}
    >
      <Center h="100%">
        <Spinner size="xl" color="blue.500" />
      </Center>
    </Box>
  );
}
